import { render, staticRenderFns } from "./logo-card.vue?vue&type=template&id=6eea2845&scoped=true&"
import script from "./logo-card.vue?vue&type=script&lang=js&"
export * from "./logo-card.vue?vue&type=script&lang=js&"
import style0 from "./logo-card.vue?vue&type=style&index=0&id=6eea2845&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eea2845",
  null
  
)

export default component.exports